import { observable, computed, action, autorunAsync, ObservableMap } from "mobx";

import { UiRepos } from "../Stores/UiStore";

export interface IAreaUiInfo {
	areaUiInfo?: AreaUiInfoImpl;
	noCollapse?: boolean;
}

export interface IContentGroupAccordionStatus {
	contentGroupAccordionStatus: ObservableMap<boolean>;
}

const asideMinWidth = 150;
const asideMaxWidth = 767;
export const asideCollapsedWidth = 12;

export class AreaUiInfoImpl implements IContentGroupAccordionStatus {

	constructor(private uiKey?: string) { }

	autoSave = autorunAsync(() => {
		if (this.uiKey)
			UiRepos.saveUiSettings(this.uiKey, this);
	});

	@action dragStart(posX : number): void {
		// start
		this.dragStartX = posX;
		this.dragDelta = 0;
		this.isDragging = true;
	}

	@action dragMove(posX: number): void {
		if (posX > 0) {
			let width = this.asideWidth + posX - this.dragStartX;
			width = Math.max(width, asideMinWidth);
			width = Math.min(width, window.innerWidth, asideMaxWidth);
			this.dragDelta = width - this.asideWidth;
		}
	}

	@action dragEnd(): void {
		this.isDragging = false;
		// set width and collapsed status
		let width = this.asideWidth + this.dragDelta;
		if (width <= asideMinWidth) {
			// too small: collapse
			this.isCollapsed = true;
		}
		else {
			// change width
			this.asideWidth = width;
		}
	}

	@action dragCancel(): void {
		this.isDragging = false;
	}

	dragStartX: number;
	@observable isDragging: boolean = false;
	@observable dragDelta: number = 0;

	@observable asideWidth: number = 300;
	@observable isCollapsed: boolean = false;

	@observable confirmSelection: boolean = false;
	@observable focus: string = "";
	treePath: Array<string> = [];
	@observable searchTerm: string = "";

	contentGroupAccordionStatus: ObservableMap<boolean> = new ObservableMap<boolean>();
	
	@action selectCollapse = () => {
		if (window.innerWidth < 767) {
			this.isCollapsed = true;
		}
	}

	@action closeExpand = () => {
		if (window.innerWidth < 767) {
			this.isCollapsed = false;
		}
	}
}

export interface IInputBooleanComponentStatus {
	inputBooleanComponentStatus: ObservableMap<boolean>;
}

export interface IInputChoiceComponentStatus {
	inputChoiceComponentStatus: ObservableMap<string>;
}

export class ExtendedAreaUiInfoImpl extends AreaUiInfoImpl implements IInputBooleanComponentStatus, IInputChoiceComponentStatus {
	inputBooleanComponentStatus: ObservableMap<boolean> = new ObservableMap<boolean>();
	inputChoiceComponentStatus: ObservableMap<string> = new ObservableMap<string>();
}